<ng-container *ngTemplateOutlet="templates['subheader'];"></ng-container>